import { useTranslation } from 'react-i18next';

/**
 * Hook to translate or post-process AI suggestion descriptions for the current language.
 * For now, just returns the string as-is, but can be extended for smarter logic.
 */
export function useTranslateSuggestionDescription() {
  // i18n available for future language-aware translation logic
  const { i18n: _i18n } = useTranslation();

  function translateDescription(description: string): string {
    // Placeholder: In future, could map AI-generated English to i18n keys or use a translation API
    // For now, just return the description as-is
    return description;
  }

  return { translateDescription };
}
